import { useProfile } from '@/src/hooks/use-profile';
import { Avatar, AvatarImage } from '@workspace/ui/components/avatar';
import { cn } from '@workspace/ui/lib/utils';
import React from 'react';
import { ProfileOptions } from './ProfileOptions';
import { Button } from '@workspace/ui/components/button';
import Link from 'next/link';

export const AvatarWithOptions = () => {
  const { data: profile } = useProfile();
  const isAnonymous = profile?.type === 'anonymous';
  if (isAnonymous) {
    return (
      <div className={isAnonymous ? '' : 'hidden'}>
        <Button
          size="sm"
          variant='secondary'
          className={cn('md:px-4 px-2 text-base py-1 border-0', {
          })}
        >
          <Link href="/sign-in" className="font-bold md:text-sm text-xs">
            Log in
          </Link>
        </Button>
      </div>
    );
  }
  return (
    <ProfileOptions profileLink={profile?.uniqueLink || ''}>
      <Avatar className={cn('size-8 flex justify-center items-center')}>
        <AvatarImage
          src={profile?.avatarUrl || '/images/default-avatar.png'}
          alt="Profile"
        />
      </Avatar>
    </ProfileOptions>
  );
};
